import { API_BASE_URL } from '../config';
import api from './axiosInstance';

export async function getTribunalesUsuarioPaged(
  page = 1,
  pageSize = 10,
  search = null,
  typeSearch = null,
  businessAreaId = null,
  sortBy = null,
  desc = false
) {
  try {
    const params = {
      page,
      pageSize,
      sortBy,
      desc,
    };

    if (search && search.trim()) {
      params.search = search.trim();
    }

    if (typeSearch) {
      params.typeSearch = typeSearch;
    }

    if (businessAreaId !== null && businessAreaId !== undefined) {
      params.businessAreaId = businessAreaId;
    }

    const response = await api.get(
      `${API_BASE_URL}/General/GetTribunalesUsuario`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        params,
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo obtener la configuración de roleo automático.';
    throw error;
  }
}

export async function updateTribunalesUsuarios(
  idUsuario,
  typeSearch,
  tribunalIds = [],
  updaterId = null,
  businessAreaId = null
) {
  try {
    const params = {
      idUsuario,
      typeSearch,
    };

    if (updaterId) {
      params.updater_id = updaterId;
    }
    if (businessAreaId !== null && businessAreaId !== undefined) {
      params.businessAreaId = businessAreaId;
    }

    const payload = Array.isArray(tribunalIds) ? tribunalIds : [];

    const response = await api.post(
      `${API_BASE_URL}/General/UpdateTribunalesUsuarios`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        params,
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo actualizar la configuración de roleo automático.';
    throw error;
  }
}

export async function updateTribunalesUsuariosExcel(file, updaterId = null) {
  try {
    const formData = new FormData();
    formData.append('file', file);

    const params = {};
    if (updaterId) {
      params.updater_id = updaterId;
    }

    const response = await api.post(
      `${API_BASE_URL}/General/UpdateTribunalesUsuariosExcel`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params,
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo importar el archivo de roleo automático.';
    throw error;
  }
}

export async function getTribunalesArea(businessAreaId) {
  try {
    const response = await api.get(
      `${API_BASE_URL}/General/GetTribunalesArea`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        params: { businessAreaId },
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo obtener los tribunales del área de negocio.';
    throw error;
  }
}

export async function updateTribunalesArea(
  businessAreaId,
  tribunalIds = []
) {
  try {
    const payload = Array.isArray(tribunalIds) ? tribunalIds : [];

    const response = await api.post(
      `${API_BASE_URL}/General/UpdateTribunalesArea`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        params: { businessAreaId },
      }
    );

    return response.data;
  } catch (error) {
    error.customMessage =
      'No se pudo actualizar los tribunales del área de negocio.';
    throw error;
  }
}

export async function getRegiones() {
  try {
    const response = await api.get(`${API_BASE_URL}/ModularTask/GetRegiones`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (error) {
    error.customMessage = 'No se pudo obtener el listado de regiones.';
    throw error;
  }
}

export async function logRoleoAutomaticoDownload(payload) {
  try {
    const response = await api.post(
      `${API_BASE_URL}/General/RoleoAutomatico/DownloadAudit`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
    return response.data;
  } catch (error) {
    // Avoid blocking download on audit failure
    console.warn('RoleoAutomatico download audit failed:', error);
    return null;
  }
}
